// extracted by mini-css-extract-plugin
module.exports = {"truncating":"styles_truncating__w87uF","link":"styles_link__ncCJZ","location":"styles_location__tGJxH"};